import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation, useMatches } from 'react-router';
import useUserPermissions from 'src/hooks/useUserPermissions';

const UserPermissionGuard = ({ children }) => {
  const location = useLocation();
  const matches = useMatches();
  const { hasPermission } = useUserPermissions();
  const exactMath = matches.find(
    ({ pathname }) => pathname === location.pathname
  );

  if (exactMath?.handle?.isEAP && !hasPermission('EAP', 'routes', exactMath)) {
    return <Navigate to="/404" />;
  }
  return children;
};

UserPermissionGuard.propTypes = {
  children: PropTypes.object
};

export default UserPermissionGuard;
